import { render, staticRenderFns } from "./sharedDocuments.vue?vue&type=template&id=2ec3b6ec&scoped=true&"
import script from "./sharedDocuments.vue?vue&type=script&lang=js&"
export * from "./sharedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./sharedDocuments.vue?vue&type=style&index=0&id=2ec3b6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3b6ec",
  null
  
)

export default component.exports